import React, { useState, useEffect } from "react";
import {
  getApiCall,
  patchApiCallWithHeader,
} from "../../../service/httpCall";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { toast } from 'react-toastify';
import {
  API_TTS_PLANS_LIST,
  API_TTS_PLANS_UPDATE,
} from "../../../service/url";
import { ROUTES } from "../../../utilities/constant";
import Loader from "../../../components/partials/components/loader";
import { errorCheck } from "../auth/auth-utils";
import { useNavigate } from "react-router-dom";
import "../../../assets/custom/css/custom.css";
import exportData from "../../../utilities/export";
import { getUser } from "../../../utilities/setting";
import { USER_ROLES, MODULE_ACL } from '../../../utilities/constant';


const VoicePlanList = () => {
  const navigate = useNavigate();
  const [statusList, setStatusList] = useState({});
  const [toastProps, setToastProps] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [voicePlan, setVoicePlan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [searchValue, setSearchValue] = useState(null);
  const [originalDataList, setOriginalDataList] = useState([]);
  const [loggedInUserACL, setLoggedInUserACL] = useState({})
  const [isSuperAdmin, setIsSuperadmin] = useState(false)

  const handleExport = async () => {
    setButtonDisable(true);
    await exportData("TTS_Plans", setToastProps, setShowToast);
    setButtonDisable(false);
  };

  const fetchVoicePlans = async () => {
    setLoading(true);
    try {
      getApiCall(API_TTS_PLANS_LIST)
        .then(onVoicePlanSuccess)
        .catch(onError)
        .finally(() => setLoading(false));
    } catch (error) {
      console.error("Error fetching voice plans:", error);
      setLoading(false);
    }
  };

   useEffect(() => {
      getUser().then((user) => {
         if (user.role === USER_ROLES.SUPERADMIN) {
            setIsSuperadmin(true);
         }
         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
      });
      fetchVoicePlans();
   }, []);

  function onVoicePlanSuccess(resp) {
    const updatedList = resp.map((val, idx) => {
      val["key"] = idx + 1;
      val["req_date"] = new Date(val["req_date"]).toGMTString();
      return val;
    });
    setVoicePlan(updatedList);
    setOriginalDataList(updatedList);
  }

  useEffect(() => {
    if (searchValue) {
      setVoicePlan(
        originalDataList.filter((data) =>
          data.plan_name
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())
        )
      );
    } else {
      setVoicePlan(originalDataList);
    }
  }, [searchValue]);

  function onError(err) {
    toast.warning(JSON.stringify(err))
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      console.log(err);
    }
  }

  const handleCreateButtonClick = () => {
    navigate(`/${ROUTES.TTSPLANS.CREATE}`);
  };

  if (loading) {
    return <Loader />;
  }

  const handleStatusToggle = async (planId, currentStatus) => {
    const newStatus = !currentStatus;

    try {
      const url = API_TTS_PLANS_UPDATE.replace(":id", planId);
      await patchApiCallWithHeader(url, {
        plan_status: newStatus ? 1 : 0,
      });

      if (!newStatus) {
        setVoicePlan((prev) => prev.filter((plan) => plan.id !== planId));
        setOriginalDataList((prev) =>
          prev.filter((plan) => plan.id !== planId)
        );
      } else {
        setVoicePlan((prev) =>
          prev.map((plan) =>
            plan.id === planId
              ? { ...plan, plan_status: 1 }
              : plan
            )
          );
        }

        toast.success(
          `Plan status updated to ${newStatus ? "Enable" : "Disable"}`
        );
      } catch (error) {
        toast.error(JSON.stringify(error));
      }
  };

  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <div className="header-title">
                  <h4 className="card-title">TTS Plans List</h4>
                </div>
                 {(isSuperAdmin || loggedInUserACL[MODULE_ACL.TTS_PLANS]?.add) && (
                  <button
                    className="btn btn-primary ml-auto"
                    onClick={handleCreateButtonClick}
                  >
                    Create TTS Plan
                  </button>
                 )}
              </Card.Header>
              <Card.Body className="px-0">
                <div className="table-responsive border-bottom my-3">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                    }}
                  >
                    {voicePlan.length > 0 && (
                      <Button
                        label="Export Data"
                        icon="pi pi-file-export"
                        onClick={handleExport}
                        className="p-button-active p-button-sm"
                        style={{ marginBottom: "10px", marginLeft: "10px" }}
                        disabled={buttonDisable}
                      >
                        &nbsp;
                        {buttonDisable && (
                          <span
                            className="spinner-border spinner-border-sm ml-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                        Export Data
                      </Button>
                    )}

                    <Form.Group style={{ height: "45px" }}>
                      <Form.Control
                        style={{
                          height: "50px",
                          marginLeft: "10px",
                          border: "1px solid #ced4da",
                          fontSize: "15px",
                          height: "45px",
                        }}
                        placeholder="Search by Plan Name..."
                        type="text"
                        maxLength={100}
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </div>
                  <div className="scroll-container mt-3">
                    <DataTable
                      value={voicePlan}
                      tableStyle={{ minWidth: "50rem" }}
                      paginator
                      rows={8}
                    >
                      <Column field="id" header="Plan ID"></Column>
                      <Column field="plan_name" header="Plan Name"></Column>
                      <Column
                        field="per_character"
                        header="Per Character"
                      ></Column>
                      <Column
                        field="per_variable"
                        header="Per Variable"
                      ></Column>

                      {/* <Column
                        field="plan_status"
                        header="Status"
                        body={(rowData) =>
                          rowData.plan_status == 1 ? "Enabled" : "Disabled"
                        }
                      /> */}
                      <Column
                        field="user.username"
                        header="Created By"
                      ></Column>
                      <Column
                        field="req_date"
                        header="Created Date"
                        body={(rowData) =>
                          new Date(rowData.req_date).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          })
                        }
                      ></Column>
                      <Column
                        header="Plan Status"
                        body={(rowData) => {
                          const isChecked =
                            statusList[rowData.id] ?? rowData.plan_status == 1; // Use statusList if set, otherwise plan_status

                          return (
                            <div
                              style={{
                                display: "flex",
                                gap: "20px",
                                textAlign: "center",
                              }}
                            >
                              <label className="slider_switch">
                                <input
                                  type="checkbox"
                                  checked={isChecked}
                                  onChange={() =>
                                    handleStatusToggle(rowData.id, isChecked)
                                  }
                                />
                                <span className="slider"></span>
                              </label>
                            </div>
                          );
                        }}
                        style={{ width: "7rem", textAlign: "center" }}
                      />
                    </DataTable>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default VoicePlanList;
